<div [style.display]="isVisible() ? 'flex' : 'none'" class="barcode-wrapper" [id]="htmlId()">
  <div class="barcode-controls">
    <button
      type="button"
      role="button"
      class="barcode-scan-button"
      [disabled]="isReadonly() || formControl?.disabled"
      (click)="onScanClick($event)">
      <div class="icon-safe-zone">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
          <path
            d="M40-120v-200h80v120h120v80H40Zm680 0v-80h120v-120h80v200H720ZM160-240v-480h80v480h-80Zm120 0v-480h40v480h-40Zm120 0v-480h80v480h-80Zm120 0v-480h120v480H520Zm160 0v-480h40v480h-40Zm80 0v-480h40v480h-40ZM40-640v-200h200v80H120v120H40Zm800 0v-120H720v-80h200v200h-80Z" />
        </svg>
      </div>
      <span>{{ this.properties.text }}</span>
    </button>
  </div>

  @if (properties.resultValue) {
    @if (isShowMode()) {
      <div class="barcode-result">
        <div class="barcode-scanned-display">
          {{
            translateService.instant('liveforms-editor.barcode-item.result.scanned-barcode', {
              barcode: properties.detectedBarcode
            })
          }}
        </div>
      </div>
    }

    @if (isCompareMode()) {
      <div class="barcode-comparison-result">
        <div
          class="scanned-barcode"
          [class.match]="properties.barcodeMatches === 'True'"
          [class.no-match]="properties.barcodeMatches === 'False'">
          @if (properties.barcodeMatches === 'True') {
            <span class="barcode-scanned-display">{{
              translateService.instant('liveforms-editor.barcode-item.result.expected-match', {
                barcode: properties.expectedBarcode
              })
            }}</span>
          } @else {
            <span class="barcode-scanned-display">{{
              translateService.instant('liveforms-editor.barcode-item.result.expected-no-match', {
                barcode: properties.expectedBarcode
              })
            }}</span>
          }
        </div>
      </div>
    }
  }

  @if (showScannerDialog()) {
    <div class="dialog-overlay" (click)="closeScannerDialog()">
      <div class="dialog-content scanner-dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>{{ translateService.instant('liveforms-editor.barcode-item.scanner.title') }}</h3>
          <button class="close-button" (click)="closeScannerDialog()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="scanner-container">
          @if (scannerErrorMessage()) {
            <div class="error-message">
              <mat-icon>error</mat-icon>
              <p>{{ scannerErrorMessage() }}</p>
            </div>
          } @else {
            @if (showScanner()) {
              <zxing-scanner
                [formats]="allowedFormats"
                [device]="currentDevice()"
                (camerasFound)="onCamerasFound($event)"
                (scanSuccess)="onCodeResult($event)"
                (permissionResponse)="onPermissionResponse($event)"
                (scanError)="onScanError($event)"
                (autostarted)="forceSetCurrentDevice()"></zxing-scanner>
              @if (availableDevices().length > 1) {
                <button type="button" class="camera-switch-button" (click)="switchCamera()">
                  <mat-icon>cameraswitch</mat-icon>
                </button>
              }
            } @else if (scannedBarcode()) {
              <div class="barcode-preview">
                <div class="preview-label">
                  {{ translateService.instant('liveforms-editor.barcode-item.scanner.result') }}
                </div>
                <div class="preview-value">{{ scannedBarcode() }}</div>
              </div>
            }
          }
        </div>

        <div class="dialog-actions">
          @if (scannedBarcode()) {
            <button type="button" class="btn-secondary" (click)="retakeScan()">
              <mat-icon>refresh</mat-icon>
              {{ translateService.instant('liveforms-editor.barcode-item.scanner.retake') }}
            </button>
            <button type="button" class="btn-primary" (click)="confirmBarcode()">
              <mat-icon>check</mat-icon>
              {{ translateService.instant('liveforms-editor.barcode-item.scanner.use-barcode') }}
            </button>
          }

          <button type="button" class="btn-secondary" (click)="closeScannerDialog()">
            {{ translateService.instant('liveforms-editor.barcode-item.scanner.cancel') }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
